<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  .tabs-select-style{
    background-color: lightgray;
    margin-top: 30px
  }
  .page-card-margin{
    margin-top: 30px
  }
</style>



// WEBPACK FOOTER //
// App.vue?3b6cfd78